import React from "react";
import { Box } from "@mui/material";
import QuinIndex from "./QuinIndex";

const Quin = () => {
  return (
    <Box
      sx={{
        m: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 600 }}>
        <QuinIndex />
      </Box>
    </Box>
  );
};

export default Quin;
